import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoutePatient = ({ children }) => {
  const isAuthenticated = localStorage.getItem("copayPatientToken");
  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default PrivateRoutePatient;
